import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

/**
 * Renders the visitor's recently viewed products inside the account signup drawer,
 * by fetching the `recently-viewed-drawer` section filtered to the locally stored product ids.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} results
 *
 * @extends Component<Refs>
 */
class RecentlyViewedDrawerComponent extends Component {
  requiredRefs = ['results'];

  connectedCallback() {
    super.connectedCallback();
    this.#render();
  }

  async #render() {
    const productIds = RecentlyViewed.getProducts();
    if (productIds.length === 0) return;

    const url = new URL(Theme.routes.search_url, window.location.origin);
    url.searchParams.set('q', productIds.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));

    const markup = await sectionRenderer.getSectionHTML('recently-viewed-drawer', false, url);
    if (!markup) return;

    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const results = parsed.getElementById('predictive-search-products');
    if (!results) return;

    this.refs.results.replaceChildren(...results.children);
  }
}

if (!customElements.get('recently-viewed-drawer-component')) {
  customElements.define('recently-viewed-drawer-component', RecentlyViewedDrawerComponent);
}
